<template>
	<div class="courses">
		<div class="filters">
			<TransitionGroup name="crossfade">
				<multi-filter key="multi" :taxonomies="['roles', 'topics', 'experiences']" />
			</TransitionGroup>
		</div>

		<main class="is-relative mt-6">
			<TransitionGroup name="crossfade">
				<div v-if="filteredCourses.length > 0" key="courses">
					<TransitionGroup name="grid" class="columns is-multiline" tag="div">
						<div
							v-for="course in filteredCourses"
							:key="course.slug"
							class="column is-half is-one-third-desktop"
						>
							<course :course="course" />
						</div>
					</TransitionGroup>
				</div>
				<div v-else-if="ready" key="placeholder" class="notification has-text-centered">
					<p>Sorry, no courses match your filters.</p>
				</div>
			</TransitionGroup>
		</main>
	</div>
</template>

<script>
import axios from 'axios';
import errorHandler from 'Utils/errorHandler.js';

import Course from './Course.vue';
import MultiFilter from './filters/Multi.vue';

export default {
	computed: {
		/* List of courses, filtered as per the user's selections */
		filteredCourses() {
			return this.getFilteredCourses(this.$store.filter.roles, this.$store.filter.topics, this.$store.filter.experiences);
		}
	},

	created() {
		/* Get courses data */
		axios.get(`/data/courses.json`)
			.then((response) => {
				/* Get available topics and industries */
				response.data.forEach(course => {
					/* Get topics */
					if (course.taxonomies?.topic) {
						course.taxonomies.topic.forEach(topic => {
							this.$store.topics[topic.slug] = topic.name;
						});
					}

					/* Get roles */
					if (course.taxonomies?.role) {
						course.taxonomies.role.forEach(role => {
							this.$store.roles[role.slug] = role.name;
						});
					}

					/* Get experiences */
					if (course.taxonomies?.experience) {
						course.taxonomies.experience.forEach(experience => {
							this.$store.experiences[experience.slug] = experience.name;
						});
					}
				});

				/* Apply initial filter, if present and valid */
				if (this.filterTopic && (this.filterTopic in this.$store.topics)) {
					this.setFilter(this.filterTopic, 'topics');
				}

				/* Save courses to data */
				this.$store.courses = response.data;
				this.$store.ready = true;
			})
			.catch(errorHandler);
	},

	props: {
		/* Pre-set topic filter from Nunjucks */
		filterTopic: {
			type: String,
			default: ''
		},
	},

	components: {
		course: Course,
		multiFilter: MultiFilter,
	},
};
</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.courses {
	min-height: 90vh;
}

.columns > .column {
	transition: all .4s ease;
	padding: $size-2;
}

.filters {
	position: relative;
	z-index: 2;
}


.grid-leave-active {
	position: absolute;
}

.grid-enter-active {
	transition-delay: .3s !important;
}

.grid-enter-to {
	transform: scale(1);
	opacity: 1;
}

.grid-enter, .grid-leave-to {
	transform: scale(.5);
	opacity: 0;
}

.crossfade-leave-to {
	transform: translateY(-3rem);
	opacity: 0;
}

.crossfade-enter {
	transform: translateY(3rem);
	opacity: 0;
}

.crossfade-enter-to {
	transform: translateY(0);
	opacity: 1;
}

.crossfade-leave-active {
	position: absolute;
	transition: transform .2s cubic-bezier(.32, 0, .67, 0), opacity .2s cubic-bezier(.32, 0, .67, 0);
}

.crossfade-enter-active {
	transition: transform .2s cubic-bezier(.33, 1, .68, 1), opacity .2s cubic-bezier(.33, 1, .68, 1);
	transition-delay: .17s;
}

.crossfade-leave-active,
.crossfade-enter-active {
	display: block;
	width: 100%;
}

</style>
